import { PlaceZone } from '../zones/zone';
import { PlaceMetadata } from './metadata';
export class PlaceZoneMetadata {
    constructor(data = {}) {
        this.zone = new PlaceZone(data.zone);
        this.keys = data.keys || [];
        this.metadata = {};
        const metadata = data.metadata || {};
        for (const key of this.keys) {
            this.metadata[key] = new PlaceMetadata(metadata[key]);
        }
    }
}
